import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import MenuSection from '../components/MenuSection';
import SpecialsSection from '../components/SpecialsSection';
import TestimonialsSection from '../components/TestimonialsSection';
import GallerySection from '../components/GallerySection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import MobileCTA from '../components/MobileCTA';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-bakery-bg dark:bg-gray-900 transition-colors duration-300" data-testid="home-page">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <MenuSection />
        <SpecialsSection />
        <TestimonialsSection />
        <GallerySection />
        <ContactSection />
      </main>
      <Footer />
      <MobileCTA />
    </div>
  );
};

export default HomePage;
